import Vue from 'vue'
import Vuex from 'vuex'

//import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    clickFiltroData: 0,
    orcamento: [],
    filtroDataInicial: null,
    filtroDataFinal: null,
    filtroOrcamento: [],
    filtroRequisicao: [],
    estatisticaRequisicoes: [],
    estatisticaRequisicoesPorLoja: [],
    estatisticaRequisicoesPorTipoCliente: [],
    estatisticaOrcamentosPorLoja: [],
    estatisticaOrcamentosPorCanal: [],
    estatisticaOrcamentosPorTipoCliente: [],
    estatisticaOrcamentosPorStatus: [],
    painelFiltroLoja: [],
    painelFiltroDataInicial: null,
    painelFiltroDataFinal: null
  },
  getters: {
    clickFiltroData(state) {
      return state.clickFiltroData
    },
    dataInicial(state) {
      return state.filtroDataInicial
    },
    dataFinal(state) {
      return state.filtroDataFinal
    },
    filtroOrcamento(state) {
      return state.filtroOrcamento
    },
    filtroRequisicao(state) {
      return state.filtroRequisicao
    },
    estatisticaRequisicoes(state) {
      return state.estatisticaRequisicoes
    },
    estatisticaRequisicoesPorLoja(state) {
      return state.estatisticaRequisicoesPorLoja
    },
    estatisticaRequisicoesPorTipoCliente(state) {
      return state.estatisticaRequisicoesPorTipoCliente
    },
    estatisticaOrcamentosPorLoja(state) {
      return state.estatisticaOrcamentosPorLoja
    },
    estatisticaOrcamentosPorCanal(state) {
      return state.estatisticaOrcamentosPorCanal
    },
    estatisticaOrcamentosPorTipoCliente(state) {
      return state.estatisticaOrcamentosPorTipoCliente
    },
    estatisticaOrcamentosPorStatus(state) {
      return state.estatisticaOrcamentosPorStatus
    },
    painelFiltroLoja(state) {
      return state.painelFiltroLoja
    },
    painelFiltroDataInicial(state) {
      return state.painelFiltroDataInicial
    },
    painelFiltroDataFinal(state) {
      return state.painelFiltroDataFinal
    }
  },
  mutations: {
    clickFiltroData(state, payload) {
      state.clickFiltroData = payload
    },
    adicionarOrcamento(state, payload) {
      state.orcamento.push(payload)
    },
    adicionarFiltroDataInicio(state, payload) {
      state.filtroDataInicial = payload
    },
    adicionarFiltroDataFinal(state, payload) {
      state.filtroDataFinal = payload
    },
    adicionarFiltroOrcamento(state, payload) {
      state.filtroOrcamento = payload
    },
    adicionarFiltroRequisicao(state, payload) {
      state.filtroRequisicao = payload
    },
    adicionarEstatisticaRequisicoes(state, payload) {
      state.estatisticaRequisicoes = payload
    },
    adicionarEstatisticaRequisicoesPorLoja(state, payload) {
      state.estatisticaRequisicoesPorLoja = payload
    },
    adicionarEstatisticaRequisicoesPorTipoCliente(state, payload) {
      state.estatisticaRequisicoesPorTipoCliente = payload
    },
    adicionarEstatisticaOrcamentosPorLoja(state, payload) {
      state.estatisticaOrcamentosPorLoja = payload
    },
    adicionarEstatisticaOrcamentosPorCanal(state, payload) {
      state.estatisticaOrcamentosPorCanal = payload
    },
    adicionarEstatisticaOrcamentosPorTipoCliente(state, payload) {
      state.estatisticaOrcamentosPorTipoCliente = payload
    },
    adicionarEstatisticaOrcamentosPorStatus(state, payload) {
      state.estatisticaOrcamentosPorStatus = payload
    },
    adicionarPainelFiltroLoja(state, payload) {
      state.painelFiltroLoja = payload
    },
    adicionarPainelFiltroDataInicial(state, payload) {
      state.painelFiltroDataInicial = payload
    },
    adicionarPainelFiltroDataFinal(state, payload) {
      state.painelFiltroDataFinal = payload
    },

  },
  actions: {
    clickFiltroData(context, payload) {
      context.commit('clickFiltroData', payload)
    },
    adicionarOrcamento(context, payload) {
      context.commit('adicionarOrcamento', payload)
    },
    adicionarFiltroDataInicio(context, payload) {
      context.commit('adicionarFiltroDataInicio', payload)
    },
    adicionarFiltroDataFinal(context, payload) {
      context.commit('adicionarFiltroDataFinal', payload)
    },
    adicionarFiltroOrcamento(context, payload) {
      context.commit('adicionarFiltroOrcamento', payload)
    },
    adicionarFiltroRequisicao(context, payload) {
      context.commit('adicionarFiltroRequisicao', payload)
    },
    adicionarEstatisticaRequisicoes(context, payload) {
      context.commit('adicionarEstatisticaRequisicoes', payload)
    },
    adicionarEstatisticaRequisicoesPorLoja(context, payload) {
      context.commit('adicionarEstatisticaRequisicoesPorLoja', payload)
    },
    adicionarEstatisticaRequisicoesPorTipoCliente(context, payload) {
      context.commit('adicionarEstatisticaRequisicoesPorTipoCliente', payload)
    },
    adicionarEstatisticaOrcamentosPorLoja(context, payload) {
      context.commit("adicionarEstatisticaOrcamentosPorLoja", payload)
    },
    adicionarEstatisticaOrcamentosPorCanal(context, payload) {
      context.commit("adicionarEstatisticaOrcamentosPorCanal", payload)
    },
    adicionarEstatisticaOrcamentosPorTipoCliente(context, payload) {
      context.commit("adicionarEstatisticaOrcamentosPorTipoCliente", payload)
    },
    adicionarEstatisticaOrcamentosPorStatus(context, payload) {
      context.commit("adicionarEstatisticaOrcamentosPorStatus", payload)
    },
    adicionarPainelFiltroLoja(context, payload) {
      context.commit("adicionarPainelFiltroLoja", payload)
    },
    adicionarPainelFiltroDataInicial(context, payload) {
      context.commit("adicionarPainelFiltroDataInicial", payload)
    },
    adicionarPainelFiltroDataFinal(context, payload) {
      context.commit("adicionarPainelFiltroDataFinal", payload)
    },
  },
})
